module.exports = __webpack_public_path__ + "img/PICT0015.8be6be26.jpg";